import { Box, Flex, Skeleton, SkeletonCircle, VStack, SkeletonText } from '@chakra-ui/react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FC } from 'react';

import { FontFamily, FontWeight } from '@/enums';
import { BREAKPOINTS } from '@/styles/themes/legacy-default';
import { ScrollbarVariant } from '@/styles/themes/scrollbar';
import { IThemeProps } from '@/styles/themes/types';

export const Root = styled.div`
  display: flex;
  height: calc(100vh - 4.5rem);
  justify-content: space-between;
`;

export const ContentContainer = styled.div<IThemeProps>`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  position: relative;
  overflow-y: auto;

  ${({ theme }) => theme.legacy.scrollbarYStyle(ScrollbarVariant.DARK)}

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    border-right: 1px solid #ccc;
  }
`;

export const Header = styled.div<IThemeProps>`
  display: flex;
  flex-direction: row;
  padding: 24px;

  @media (max-width: ${BREAKPOINTS.Mobile.max}px) {
    padding: 24px 0 8px 24px;
    max-width: 80%;
  }
`;

export const InformationContainer = styled.div<IThemeProps>`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Title = styled.h1<IThemeProps>`
  font-weight: ${FontWeight.bold};
  font-family: ${({ theme }) => theme.legacy.typography.fontFamily[FontFamily.SpaceGrotesk]};
  font-size: 20px;
  color: ${({ theme }) => theme.legacy.colors.defaultText};
  margin-top: 8px;
  line-height: 28px;

  @media (max-width: ${BREAKPOINTS.Mobile.max}px) {
    font-size: 18px;
  }
`;

export const SidebarContainer = styled.div<IThemeProps>`
  background-color: ${({ theme }) => theme.legacy.colors.white};
  height: 100%;
  min-width: 370px;
  max-width: 370px;
  display: none;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    display: block;
  }
`;

export const EventContentSkeleton: FC = () => {
  return (
    <Box h="100vh">
      <Flex justifyContent="space-between" h="65px" borderBottom="1px" borderColor="gray.200" mb="2" p="2">
        <Skeleton w="50px" h="full" />
        <SkeletonCircle alignSelf="center" mr="2" />
      </Flex>

      <Flex h="full">
        <VStack p="2" w="80px" h="full" borderRight="1px" borderColor="gray.200" spacing="4">
          <Skeleton w="full" h="50px" />
          <Skeleton w="full" h="50px" />
          <Skeleton w="full" h="50px" />
          <Skeleton w="full" h="50px" />
          <Skeleton w="full" h="50px" />
        </VStack>
        <Box flex="1" ml="4">
          <SkeletonText my="4" noOfLines={3} spacing="4" />
          <Flex mt="8">
            <Skeleton w="45px" h="20px" mr="3" />
            <Skeleton w="45px" h="20px" mr="3" />
            <Skeleton w="45px" h="20px" mr="3" />
          </Flex>
          <Skeleton h="500px" mt="5" />
        </Box>
        <Box w="360px" mr="2">
          <Skeleton h="800px" mt="5" ml="5" />
        </Box>
      </Flex>
    </Box>
  );
};
